import React, { memo } from 'react';
import LikelihoodPannel from '../../components/likelihoodPannel';
import LevelBar from '../../components/levelBar';
import LevelofIntegration from '../../components/levelOfIntegration';
import RequirementForTSAs from '../../components/complexitySwitch';
import ImportanceSlider from '../../components/complexitySlider';

import './strategy.scss';

const comp = {
  1: LevelofIntegration,
  2: ImportanceSlider,
  3: RequirementForTSAs,
  4: LikelihoodPannel,
  5: ImportanceSlider,
  6: ImportanceSlider,
  7: LevelBar,
};

function Strategy(props) {
  const Content = props.c;
  return (
    <Content
      {...props}
      comp={comp}
      showSubSection={false}
      showContentAsSubtitle
    />
  );
}

export default memo(Strategy);
